module.exports = __webpack_public_path__ + "static/media/huoyanshan_package.d10f2f32.webp";